import { render, staticRenderFns } from "./Solicitud.vue?vue&type=template&id=2d57ac3c&scoped=true"
import script from "./Solicitud.vue?vue&type=script&lang=js"
export * from "./Solicitud.vue?vue&type=script&lang=js"
import style0 from "./Solicitud.vue?vue&type=style&index=0&id=2d57ac3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d57ac3c",
  null
  
)

export default component.exports